<template>
  <div class="float-left boss-check-container boss-batch-select">
    全<span
      class="boss-check-number"
      data-test="selector-check-number"
    >{{ displayCountText }}</span>名
    <span data-test="page-label">{{ countPageLabel }}</span>
    <template v-if="showSelector">
      <span data-test="selector-label-start">    このページの先頭から</span>
      <input
        v-model="selectLength"
        class="boss-input"
        data-test="selector-input"
        type="number"
        :max="Number.MAX_SAFE_INTEGER"
        min="0"
        @keypress="onlyNumberInRange($event)"
      >名を
      <button
        class="boss-button boss-exe-button pega-button pega-mr-5 pega-bulk-button"
        :disabled="!Number(selectLength)"
        data-test="all-checked-on"
        @click="allCheckedOn()"
      >
        <span class="boss-exe-button-text">選択する</span>
      </button>
      <button
        class="boss-button boss-exe-button pega-button pega-mr-5 pega-bulk-button"
        data-test="all-checked-off"
        @click="allCheckedOff()"
      >
        <span class="boss-exe-button-text">全て解除する</span>
      </button>
    </template>
  </div>
</template>

<script>
import eventValidations from '@/lib/eventValidations'
export default {
  mixins: [eventValidations],
  props: {
    displayCount: {
      type: Number,
      default: undefined
    },
    countFrom: {
      type: Number,
      default: undefined
    },
    countTo: {
      type: Number,
      default: undefined
    },
    isPaging: {
      type: Boolean,
      default: false
    },
    showSelector: {
      type: Boolean,
      default: true
    },
    selectLimit: {
      // デフォルト値はMax1000件とする
      type: Number,
      default: 1000
    }
  },
  data () {
    return {
      isChecked: false,
      selectLength: 0
    }
  },
  computed: {
    countPageLabel () {
      return (this.isPaging && this.displayCount !== 0)
        ? `  ${this.countFrom || '...'}〜${this.countTo || '...'}名まで表示中`
        : ''
    },
    displayCountText () {
      return (this.displayCount === undefined || this.displayCount === null) ? '...' : this.displayCount
    }
  },
  watch: {
    displayCount: {
      handler: 'roundAndSetSelectLength',
      immediate: true
    }
  },
  methods: {
    allCheckedOn () {
      this.$emit('selectedMembers', this.selectLength, true)
    },
    allCheckedOff () {
      this.$emit('selectedMembers', this.displayCount, false)
    },
    roundAndSetSelectLength () {
      this.$set(this, 'selectLength', this.displayCount > this.selectLimit ? this.selectLimit : this.displayCount)
    }
  }
}
</script>
